(function (factory) {
	var moduleName = "dsPlainGallery";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName, ["jquery"], factory);
		return;
	}

	var moduleExport = factory(window.ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function($) {
	window.ccs_ds_plainGallery = {

		/* Initializes a gallery.
		----------------------------------------------------------*/
		initialize: function (gal) {

			gal.area = $("#" + gal.id);
			if (gal.area.length == 0)
				return;

			setupZoom(gal);
			setupImages(gal);

			gal.area.show();

			/* Setups zoom properties.
			----------------------------------------------------------*/
			function setupZoom(gal) {

				gal.zoomOnClass = "ccs-ds-gallery-zoom-on-" + gal.zoomDir;

				gal.area.find("div.ccs-ds-plainGallery-item div.ccs-ds-plainGallery-zoom").each(function() {
						bindZoomOff(gal, $(this));
					});
			}

			/* Binds click handlers to enlarged images.
			----------------------------------------------------------*/
			function bindZoomOff(gal, zoom) {

				zoom.bind("click", function () {
						zoom.unbind("click");
						zoomOff(gal, zoom.parent());
						return false;
					});
			}

			/* Setups images properties.
			----------------------------------------------------------*/
			function setupImages(gal) {

				gal.area.find("div.ccs-ds-plainGallery-image").mouseover(function () {
					$(this).find("." + gal.zoomOnClass).show();
				}).mouseleave(function () {
					$(this).find("." + gal.zoomOnClass).hide();
				}).click(function () {
					gal.area.children().each(function () {
						var zoom = $(this).find("div.ccs-ds-plainGallery-zoom");
						if (zoom.css("display") == "block")
							zoom.click();
					});
					zoomOn(gal, $(this).parent());
					return false;
				});
			}

			/* Enlarges specified image.
			----------------------------------------------------------*/
			function zoomOn(gal, item) {

				var thumb = item.find("div.ccs-ds-plainGallery-image > img");
				var thumbWidth = thumb.width();
				var thumbHeight = thumb.height();

				var zoom = item.find("div.ccs-ds-plainGallery-zoom");
				var origin = zoom.find("img");
				var originDims = getOriginalDimensions(origin);
				var originWidth = originDims[0];
				var originHeight = originDims[1];
				origin.width(thumbWidth);

				// log zoom event
				eval(origin.data("zoom-log-call"));

				// IE7 z-index bug
				zoom.parent().css("z-index", "10001");

				var zoomIcon = zoom.find("div");

				var zoomMove;
				switch (gal.zoomDir) {
				case "lt":
					zoomMove = {
						width: originWidth + "px",
						left: "-" + (originWidth - thumbWidth) + "px",
						top: "-" + (originHeight - thumbHeight) + "px"
					};
					zoomIcon.css("left", (thumbWidth + 1 - 30) + "px");
					zoomIcon.css("top", (thumbHeight + 1 - 20) + "px");
					break;
				case "rt":
					zoomMove = {
						width: originWidth + "px",
						top: "-" + (originHeight - thumbHeight) + "px"
					};
					zoomIcon.css("left", "1px");
					zoomIcon.css("top", (thumbHeight + 1 - 20) + "px");
					break;
				case "rb":
					zoomMove = {
						width: originWidth + "px"
					};
					zoomIcon.css("left", "1px");
					zoomIcon.css("top", "1px");
					break;
				case "lb":
					zoomMove = {
						width: originWidth + "px",
						left: "-" + (originWidth - thumbWidth) + "px"
					};
					zoomIcon.css("left", (thumbWidth + 1 - 30) + "px");
					zoomIcon.css("top", "1px");
					break;
				}

				zoom.show();

				origin.animate(
					zoomMove,
					{
						duration: "fast",
						queue: false
					});
			}

			/* Narrows the enlarged image back.
			----------------------------------------------------------*/
			function zoomOff(gal, item) {

				var thumb = item.find("div.ccs-ds-plainGallery-image > img");
				var thumbWidth = thumb.width();
				var thumbHeight = thumb.height();

				var zoom = item.find("div.ccs-ds-plainGallery-zoom");
				var origin = zoom.find("img");

				origin.animate(
				{ width: thumbWidth + "px", left: "0px", top: "0px" },
				{
					duration: "fast",
					complete: function () {
						// IE7 z-index bug
						zoom.parent().css("z-index", "");

						zoom.hide();
						bindZoomOff(gal, zoom);
					},
					queue: false
				});
			}

			/* Gets original image dimensions from its ID.
			----------------------------------------------------------*/
			function getOriginalDimensions(elem) {

				var parts = elem.attr("id").split("-");
				var dims = parts[parts.length - 1].split("x");
				return dims;
			}
		}
	};
}));
